import { render, staticRenderFns } from "./tr-pair-list.vue?vue&type=template&id=5b980e4e&"
import script from "./tr-pair-list.vue?vue&type=script&lang=js&"
export * from "./tr-pair-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports